import React from 'react';

export default function PdfViewerLayout({ 
  isSidebarVisible, 
  onToggleSidebar, 
  sidebar, 
  mainContent 
}) {
  return (
    <>
      <div className="main-content">
        <div className="viewer-container">
          {mainContent}
        </div>
      </div>

      {/* --- BUTTON 1: THE EDGE TOGGLE ---
          Visible ONLY when sidebar is hidden. 
          Fixed to the right edge of the screen. */}
      <button 
        className={`edge-toggle ${isSidebarVisible ? 'hidden' : ''}`}
        onClick={onToggleSidebar}
        aria-label="Show sidebar"
      >
        <span className="toggle-arrow"></span>
      </button>

      {/* --- SIDEBAR CONTAINER --- */}
      <div className={`file-browser ${isSidebarVisible ? 'sidebar-visible' : ''}`}>
        
        {/* --- BUTTON 2: THE ATTACHED TOGGLE ---
            Visible ONLY when sidebar is visible.
            Moves with the sidebar. */}
        <button 
          className="sidebar-toggle" 
          onClick={onToggleSidebar}
          aria-label="Hide sidebar"
        >
          <span className="toggle-arrow"></span>
        </button>
        
        <div className="sidebar-content">
          {sidebar}
        </div>
      </div>
    </>
  );
}